import { ref } from 'vue';

const alerts = ref([]);

export function useAlerts() {
  let ID_COUNTER = 0;

  function notify(title, subtitle, type) {
    const id = ID_COUNTER++;
    alerts.value.push({
      id,
      title,
      subtitle,
      type,
    });

    setTimeout(() => {
      dismiss(id);
    }, 5 * 1000);
  }

  function success(title, subtitle) {
    notify(title, subtitle || '', 'success');
  }
  function error(title, subtitle) {
    notify(title, subtitle || '', 'danger');
  }
  function warn(title, subtitle) {
    notify(title, subtitle || '', 'warning');
  }
  function info(title, subtitle) {
    notify(title, subtitle || '', 'info');
  }

  function dismiss(id) {
    const idx = alerts.value.findIndex(i => i.id === id);
    if (idx === -1) {
      return;
    }

    alerts.value.splice(idx, 1);
  }

  function dismissAll() {
    alerts.value.map(alert => {
      alerts.value.splice(alert.id, 1);
    });
    ID_COUNTER = 0;
  }

  return {
    alerts,
    success,
    info,
    error,
    warn,
    dismiss,
    dismissAll,
  };
}
